
<!--
  ~ VNCcontact+ : A new level of contact management
  ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, version 3 of the License.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. Look for COPYING file in the top folder.
  ~ If not, see http://www.gnu.org/licenses/.
  -->

<div class="contact-dialog">
    <div class="contact__dialog-header">
        <div class="mobile-back-button">
            <button mat-button (click)="close()">
                <mat-icon class="mdi-20px" fontSet="mdi" fontIcon="mdi-close"></mat-icon>
            </button>
        </div>
        <div class="header_lbl disable-select">
            {{ 'PROFILE_LBL' | translate }}
        </div>
        <div class="mobile-back-button" (click)="openRecentActivityDialog()" *ngIf=showHistoryButtonTop>
            <button mat-button>
                <mat-icon class="mdi-20px disable-select" fontSet="mdi" fontIcon="mdi-history"></mat-icon>
            </button>
        </div>
        <div class="mobile-back-button">
            <button mat-button (click)="editContact()">
                <mat-icon class="disable-select">edit</mat-icon>
            </button>
        </div>
        <div class="mobile-back-button">
            <button mat-button [matMenuTriggerFor]="contactOperationMenu">
                <mat-icon class="disable-select">more_vert</mat-icon>
            </button>
        </div>
        <div class="desktop-close-button">
            <button mat-button (click)="editContact()">
                <mat-icon class="disable-select">edit</mat-icon>
            </button>
            <button mat-button (click)="close()">
                <mat-icon class="disable-select">close</mat-icon>
            </button>
        </div>
    </div>
    <div class="contact__dialog-body contact__dialog-body--pad" (scroll)="scrollingDialog($event)">
        <div class="content" (scroll)="scrollingPage($event)">
            <div class="parent-item">
                <div [ngStyle]="backgroundImageStyle" class="background-imge-avatar"></div>
                <div class="star-item" *ngIf="!contact.isGroup">
                    <mat-icon fontSet="mdi" fontIcon="mdi-star-outline" *ngIf="!contact.favorite" (click)="markAsFavoriteContact(true, contact)"></mat-icon>
                    <mat-icon class="favorite-mark" fontSet="mdi" fontIcon="mdi-star" *ngIf="contact.favorite" (click)="markAsFavoriteContact(false, contact)"></mat-icon>
                </div>
                <div class="parent-item-user-name">
                    <div class="user-avtar">
                        <vp-avatar
                            [user]="{firstLastCharacters: contact?.fullName.charAt(0), emails: contact.emails, jid: contact.jid, color: contact.bgAvatarColor, avatarURL: contact.avatar}">
                        </vp-avatar>
                    </div>
                    <div id="profile-user-name" class="user-name">
                        <span>
                            {{ (contact.fullName) ? ((contact.fullName.length > 30) ? contact.fullName.substr(0, 30) +
                                '...': contact.fullName): null }}
                        </span>
                        <span class="mobile-recent-activity-button" (click)="openRecentActivityDialog()" *ngIf=!showHistoryButtonTop>
                            <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-history"></mat-icon>
                        </span>
                    </div>
                </div>
            </div>
            <div class="operation-stripe">
                <div class="item" (click)="startAudioCall()" *ngIf="isShowTalkOptions">
                    <div class="icon">
                        <mat-icon fontSet="mdi" fontIcon="mdi-phone"></mat-icon>
                    </div>
                    <div class="text">{{ 'AUDIO_CALL' | translate }}</div>
                </div>
                <div class="item" (click)="startVideoCall()" *ngIf="isShowTalkOptions">
                    <div class="icon">
                        <mat-icon fontSet="mdi" fontIcon="mdi-video"></mat-icon>
                    </div>
                    <div class="text">{{'VIDIO_CALL' | translate }}</div>
                </div>
                <div class="item" (click)="startChat()" *ngIf="isShowTalkOptions">
                    <div class="icon">
                        <mat-icon fontSet="mdi" fontIcon="mdi-message"></mat-icon>
                    </div>
                    <div class="text">{{ 'CHAT_LEBALE' | translate }}</div>
                </div>
                <div class="item" (click)="shareScreen()" *ngIf="isShowTalkOptions && !isOnMobile">
                    <div class="icon">
                        <mat-icon fontSet="mdi" fontIcon="mdi-monitor-share"></mat-icon>
                    </div>
                    <div class="text">{{ 'SHARE_SCREEN' | translate }}</div>
                </div>
                <div class="item" (click)="startMail()" *ngIf="isShowSendEmailOption">
                    <div class="icon">
                        <mat-icon fontSet="mdi" fontIcon="mdi-email"></mat-icon>
                    </div>
                    <div class="text">{{'EMAIL_LBL' | translate }}</div>
                </div>
                <div class="item" (click)="composeEvent()" *ngIf="isShowCalendarOption">
                    <div class="icon">
                        <mat-icon fontSet="mdi" fontIcon="mdi-calendar-plus"></mat-icon>
                    </div>
                    <div class="text">{{'CALENDAR_EVENT' | translate }}</div>
                </div>
                <div class="item" (click)="createTask()" *ngIf="isShowTaskOption">
                    <div class="icon">
                        <mat-icon fontSet="mdi" fontIcon="mdi-clipboard-check"></mat-icon>
                    </div>
                    <div class="text">{{'TASK' | translate }}</div>
                </div>
                <div class="item" (click)="createTicket()" *ngIf="isShowTicketOption">
                    <div class="icon">
                        <mat-icon fontSet="mdi" fontIcon="mdi-ticket"></mat-icon>
                    </div>
                    <div class="text">{{'TICKET' | translate }}</div>
                </div>
            </div>
            <div class="detail-contact">
                <mat-tab-group>
                    <mat-tab label="{{ 'CONTACT_INFO' | translate }}">
                        <div class="detail-contact-tab">
                            <div class="detail-item">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-account"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'FIRST_LAST_NAME_TITLE' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        {{ (contact.fullName) ? ((contact.fullName.length > 30) ? contact.fullName.substr(0, 30) +
                                            '...': contact.fullName): null }}
                                    </div>
                                    <mat-divider></mat-divider>
                                </div>
                            </div>
                            <div class="detail-item" *ngIf="contact.company || contact.jobTitle">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-city"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'COMPANY_JOB_POSITION' | translate }}
                                    </div>
                                    <div>
                                        <span *ngIf="contact.company"> {{ contact.company }}</span>
                                        <span *ngIf="contact.company && contact.jobTitle">
                                            <mat-icon class="seprator">fiber_manual_record</mat-icon>
                                        </span>
                                        <span *ngIf="contact.jobTitle" class="type">{{ contact.jobTitle }}</span>
                                    </div>
                                    <mat-divider></mat-divider>
                                </div>
                            </div>
                            <div *ngIf="!contact.isGroup && contact.address && contact.address.length > 0">
                                <div class="detail-item" *ngFor="let address of contact.address; let i= index;">
                                    <div class="icon">
                                        <mat-icon *ngIf="i===0" class="mdi-18px" fontSet="mdi" fontIcon="mdi-map-marker"></mat-icon>
                                    </div>
                                    <div class="detail">
                                        <div class="lable-detail" *ngIf="i===0">
                                            {{ 'ADDRESS' | translate }}
                                        </div>
                                        <div *ngIf="lang !== 'de'">
                                            <span (click)="parseAddressLocation(address)">
                                                {{ getAddress(address) }}
                                             </span>
                                             <span>
                                                 <mat-icon class="seprator">fiber_manual_record</mat-icon>
                                             </span>
                                             <span class="type">
                                                {{ (address.address_type === "home" ? 'ADDRESS_TYPE.HOME' : address.address_type === "work" ? 'ADDRESS_TYPE.WORK' : 'ADDRESS_TYPE.OTHER') | translate }}
                                             </span>
                                        </div>
                                        <div *ngIf="lang === 'de'">
                                            <span class="background-text-color" (click)="parseAddressLocation(address)">
                                                <span>
                                                    <mat-icon class="seprator">fiber_manual_record</mat-icon>
                                                </span>
                                                <span class="type">
                                                    {{ (address.address_type === "home" ? 'ADDRESS_TYPE.HOME' : address.address_type === "work" ? 'ADDRESS_TYPE.WORK' : 'ADDRESS_TYPE.OTHER') | translate }}
                                                </span>
                                                <div *ngIf='address.street1 && address.street1 !== null && address.street1 !== ""' class="address-text-size">
                                                    {{ address.street1 }}
                                                </div>
                                                <div>
                                                    <div>
                                                        <span *ngIf='address.postcode && address.postcode !== null && address.postcode !== ""' class="address-text-size"> {{address.postcode}} </span>
                                                        <span *ngIf='address.city && address.city !== null && address.city !== ""' class="address-text-size"> {{ address.city }} </span>
                                                    </div>
                                                    <span *ngIf='address.state && address.state !== null && address.state !== ""' class="address-text-size">  {{address.state}} </span>
                                                </div>
                                                <span *ngIf='address.country_code && address.country_code !== null && address.country_code !== ""' class="address-text-size">
                                                    {{address.country_code}}
                                                </span>
                                             </span>
                                        </div>
                                        <mat-divider *ngIf="(i===contact.address.length - 1)"></mat-divider>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="!contact.isGroup && contact.phones?.length > 0">
                                <div class="detail-item" *ngFor="let phone of contact.phones; let i= index;">
                                    <div class="icon">
                                        <mat-icon *ngIf="i===0" class="mdi-18px" fontSet="mdi" fontIcon="mdi-phone"></mat-icon>
                                    </div>
                                    <div class="detail">
                                        <div class="lable-detail" *ngIf="i===0">
                                            {{ 'PHONE_MOBILE_FAX' | translate }}
                                        </div>
                                        <div>
                                            <span>
                                                {{ phone.phone}}
                                            </span>
                                            <span>
                                                <mat-icon class="seprator">fiber_manual_record</mat-icon>
                                            </span>
                                            <span class="type">
                                                {{ (phone.phone_type === "home" ? 'PHONE_TYPE.HOME' : phone.phone_type === "work" ? 'PHONE_TYPE.WORK' : 'PHONE_TYPE.OTHER') | translate }}
                                            </span>
                                        </div>
                                        <mat-divider *ngIf="(i===contact.phones.length - 1)"></mat-divider>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="!contact.isGroup && contact.emails?.length > 0">
                                <div class="detail-item" *ngFor="let email of contact.emails; let i= index;">
                                    <div class="icon">
                                        <mat-icon *ngIf="i===0" class="mdi-18px" fontSet="mdi" fontIcon="mdi-email"></mat-icon>
                                    </div>
                                    <div class="detail">
                                        <div class="lable-detail" *ngIf="i===0">
                                            {{ 'EMAILS' | translate }}
                                        </div>
                                        <div>
                                            <span>
                                                {{ email.email}}
                                            </span>
                                        </div>
                                        <mat-divider *ngIf="(i===contact.emails.length - 1)"></mat-divider>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="!contact.isGroup && contact.urls?.length > 0">
                                <div class="detail-item" *ngFor="let url of contact.urls; let i= index;">
                                    <div class="icon">
                                        <mat-icon *ngIf="i===0" class="mdi-18px" fontSet="mdi" fontIcon="mdi-link"></mat-icon>
                                    </div>
                                    <div class="detail">
                                        <div class="lable-detail" *ngIf="i===0">
                                            {{ 'WEBSITE' | translate }}
                                        </div>
                                        <div>
                                            <span>
                                                {{ url.url }}
                                            </span>
                                            <span>
                                                <mat-icon class="seprator">fiber_manual_record</mat-icon>
                                            </span>
                                            <span class="type">
                                                {{ (url.url_type === "home" ? 'URL_TYPE.HOME' : url.url_type === "work" ? 'URL_TYPE.WORK' : 'URL_TYPE.OTHER') | translate }}
                                            </span>
                                        </div>
                                        <mat-divider *ngIf="(i===contact.urls.length - 1)"></mat-divider>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="!contact.isGroup && contact.events && contact.events.length > 0">
                                <div class="detail-item" *ngFor="let event of contact.events; let i= index;">
                                    <div class="icon">
                                        <mat-icon *ngIf="i===0" class="mdi-18px" fontSet="mdi" fontIcon="mdi-cake-variant"></mat-icon>
                                    </div>
                                    <div class="detail">
                                        <span>
                                            {{ event.event_date | date: 'M/d/yyyy' }}
                                        </span>
                                        <span>
                                            <mat-icon class="seprator">fiber_manual_record</mat-icon>
                                        </span>
                                        <span class="type">
                                            {{ (event.event_type === "birthday" ? 'CONTACT_EVENT_TYPE.BIRTHDAY' : event.event_type === "anniversary" ? 'CONTACT_EVENT_TYPE.ANNIVERSARY' : 'CONTACT_EVENT_TYPE.CUSTOM') | translate }}
                                        </span>
                                        <mat-divider *ngIf="(i===contact.events.length - 1)"></mat-divider>
                                    </div>
                                </div>
                            </div>
                            <div class="detail-caption-title">
                                {{ 'CONTACT_DETAILS' | translate }}
                            </div>
                            <div class="detail-item" *ngIf="contact.timezone">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-calendar-clock"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'TIME_ZONE' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        {{ contact.timezone }}
                                    </div>
                                    <mat-divider></mat-divider>
                                </div>
                            </div>
                            <div class="detail-item" *ngIf="contact.language">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-flag"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'LANGUAGE_LABEL' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        {{ contact.language }}
                                    </div>
                                    <mat-divider></mat-divider>
                                </div>
                            </div>
                            <div *ngIf="!contact.isGroup && contact.skills && contact.skills.length > 0">
                                <div class="detail-item">
                                    <div class="icon list-chips-icon margin-top-15">
                                        <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-account"></mat-icon>
                                    </div>
                                    <div class="detail list-chips">
                                        <div class="lable-detail">
                                            {{ 'SKILLS' | translate }}
                                        </div>
                                        <div>
                                            <mat-chip-list #contactChipList>
                                                <mat-chip
                                                  *ngFor="let skill of contact.skills"
                                                  [selectable]="true"
                                                  [removable]="false"
                                                  [ngStyle]="{'background': '#607D8B'}"
                                                  >
                                                  <span class="name">{{skill.name}}</span>
                                                </mat-chip>
                                            </mat-chip-list>
                                        </div>
                                        <mat-divider></mat-divider>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="!contact.isGroup && contact.interests && contact.interests.length > 0">
                                <div class="detail-item">
                                    <div class="icon list-chips-icon margin-top-15">
                                        <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-guitar-acoustic"></mat-icon>
                                    </div>
                                    <div class="detail list-chips">
                                        <div class="lable-detail">
                                            {{ 'INTERESTS' | translate }}
                                        </div>
                                        <div>
                                            <mat-chip-list #contactChipList>
                                                <mat-chip
                                                  *ngFor="let interest of contact.interests"
                                                  [selectable]="true"
                                                  [removable]="false"
                                                  [ngStyle]="{'background': '#607D8B'}"
                                                  >
                                                  <span class="name">{{interest.name}}</span>
                                                </mat-chip>
                                            </mat-chip-list>
                                        </div>
                                        <mat-divider></mat-divider>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="!contact.isGroup && contact.tags && contact.tags.length > 0">
                                <div class="detail-item">
                                    <div class="icon list-chips-icon margin-top-15">
                                        <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-tag"></mat-icon>
                                    </div>
                                    <div class="detail list-chips">
                                        <div class="lable-detail">
                                            {{ 'TAGS' | translate }}
                                        </div>
                                        <div>
                                            <span>
                                                <mat-chip-list #contactChipTag>
                                                    <mat-chip
                                                      *ngFor="let tag of contact.tags"
                                                      [selectable]="true"
                                                      [removable]="false"
                                                      class="tag-list-chip"
                                                      [ngStyle]="{'background': tag.color_hex ? tag.color_hex : '#888888'}"
                                                      >
                                                      <span class="name">{{tag.name}}</span>
                                                    </mat-chip>
                                                </mat-chip-list>
                                            </span>
                                        </div>
                                        <mat-divider></mat-divider>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="!contact.isGroup && contact.contact_list && contact.contact_list.length > 0">
                                <div class="detail-item">
                                    <div class="icon list-chips-icon margin-top-15">
                                        <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-account-box-multiple"></mat-icon>
                                    </div>
                                    <div class="detail list-chips">
                                        <div class="lable-detail">
                                            {{ 'LISTS_LBL' | translate }}
                                        </div>
                                        <div>
                                            <span>
                                                <mat-chip-list #contactChipList>
                                                    <mat-chip
                                                      *ngFor="let list of contact.contact_list"
                                                      [selectable]="true"
                                                      [removable]="false"
                                                      [ngStyle]="{'background': list.color_hex !== null ? list.color_hex : '#888888'}"
                                                      >
                                                      <span class="name">{{list.name}}</span>
                                                    </mat-chip>
                                                </mat-chip-list>
                                            </span>
                                        </div>
                                        <mat-divider></mat-divider>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="!contact.isGroup && contact.notes">
                                <div class="detail-item">
                                    <div class="icon">
                                        <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-note-text"></mat-icon>
                                    </div>
                                    <div class="detail">
                                        <span>
                                            {{ contact.notes }}
                                        </span>
                                        <mat-divider></mat-divider>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab label="{{ 'HR_DATA' | translate }}" *ngIf="contact?.contains_hr_data === 'true'">
                        <!-- Add Content for HR Data -->
                        <div class="detail-contact-tab">
                            <div class="detail-item" *ngIf="!contact.isGroup && contact.birthday">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-cake"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'DATE_OF_BIRTH' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        {{ contact.birthday | date: "d. MMMM y"}}
                                    </div>
                                    <mat-divider></mat-divider>
                                </div>
                            </div>
                            <div class="detail-item" *ngIf="!contact.isGroup && (contact.gender || contact.marital_status)">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-human-male-female"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="multi-field">
                                        <div class="width-20">
                                            <div class="lable-detail">
                                                {{ 'GENDER' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.gender}}
                                            </div>
                                        </div>
                                        <div>
                                            <div class="lable-detail">
                                                {{ 'MARITAL_STATUS' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.marital_status}}
                                            </div>
                                        </div>
                                    </div>
                                    <mat-divider></mat-divider>
                                </div>
                            </div>
                            <div class="detail-item" *ngIf="!contact.isGroup && contact.private_email">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-email"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'PRIVATE_EMAIL' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        {{ contact.private_email}}
                                    </div>
                                    <mat-divider></mat-divider>
                                </div>
                            </div>
                            <div class="detail-item" *ngIf="!contact.isGroup && contact.vnc_employee">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-account"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'ENGAGEMENT_TYPE' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        <span *ngIf="contact.vnc_employee === 'true'">
                                            {{ 'VNC_EMPLOYEE' | translate }}
                                        </span>
                                        <span *ngIf="contact.vnc_employee === 'false'">
                                            {{ 'NOT_VNC_EMPLOYEE' | translate }}
                                        </span>
                                    </div>
                                    <mat-divider></mat-divider>
                                </div>
                            </div>
                            <div class="detail-item" *ngIf="!contact.isGroup && (contact.start_date || contact.end_date)">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-calendar-today"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="multi-field">
                                        <div class="width-20" *ngIf="contact.start_date">
                                            <div class="lable-detail">
                                                {{ 'START_DATE' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.start_date | date: "d. MMMM y"}}
                                            </div>
                                        </div>
                                        <div *ngIf="contact.end_date">
                                            <div class="lable-detail">
                                                {{ 'END_DATE' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.end_date | date: "d. MMMM y"}}
                                            </div>
                                        </div>
                                    </div>
                                    <mat-divider></mat-divider>
                                </div>
                            </div>

                            <div class="detail-item" *ngIf="!contact.isGroup && (contact.per_week_availability || contact.hourly_rate || contact.payment_mode)">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-currency-usd-circle-outline"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="multi-field">
                                        <div class="width-20" *ngIf="contact.per_week_availability">
                                            <div class="lable-detail">
                                                {{ 'PER_WEEK_AVAILABLILITY' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.per_week_availability}}
                                            </div>
                                        </div>
                                        <div *ngIf="contact.hourly_rate" class="width-20">
                                            <div class="lable-detail">
                                                {{ 'HOURLY_RATE' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.hourly_rate}}
                                            </div>
                                        </div>
                                        <div *ngIf="contact.payment_mode">
                                            <div class="lable-detail">
                                                {{ 'PAYMENT_MODE' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.payment_mode}}
                                            </div>
                                        </div>
                                    </div>
                                    <mat-divider></mat-divider>
                                </div>
                            </div>

                            <div *ngIf="!contact.isGroup && contact.im_accounts && contact.im_accounts.length > 0">
                                <div class="detail-item" *ngFor="let im of contact.im_accounts; let i= index;">
                                    <div class="icon">
                                        <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-forum" *ngIf="i === 0"></mat-icon>
                                    </div>
                                    <div class="detail">
                                        <span>
                                            {{ im.im_id }}
                                        </span>
                                        <span>
                                            <mat-icon class="seprator">fiber_manual_record</mat-icon>
                                        </span>
                                        <span class="type">
                                            {{ im.im_type }}
                                        </span>
                                        <mat-divider *ngIf="(i===contact.im_accounts.length - 1)"></mat-divider>
                                    </div>
                                </div>
                            </div>
                            <div class="detail-item" *ngIf="!contact.isGroup && (contact.passport_number || contact.passport_expiry)">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-passport"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="multi-field">
                                        <div class="width-20" *ngIf="contact.passport_number">
                                            <div class="lable-detail">
                                                {{ 'PASSPORT_NUMBER' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.passport_number}}
                                            </div>
                                        </div>
                                        <div *ngIf="contact.passport_expiry">
                                            <div class="lable-detail">
                                                {{ 'PASSPORT_EXPIRY' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.passport_expiry | date: "d. MMMM y"}}
                                            </div>
                                        </div>
                                    </div>
                                    <mat-divider></mat-divider>
                                </div>
                            </div>

                            <div class="detail-item" *ngIf="!contact.isGroup && (contact.national_id_number || contact.national_id_expiry)">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-account-card-details"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="multi-field">
                                        <div class="width-20" *ngIf="contact.national_id_number">
                                            <div class="lable-detail">
                                                {{ 'NATIONAL_ID_NUMBER' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.national_id_number}}
                                            </div>
                                        </div>
                                        <div *ngIf="contact.national_id_expiry !== null">
                                            <div class="lable-detail">
                                                {{ 'NATIONAL_ID_EXPIRY' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.national_id_expiry | date: "d. MMMM y"}}
                                            </div>
                                        </div>
                                    </div>
                                    <mat-divider></mat-divider>
                                </div>
                            </div>

                        </div>
                    </mat-tab>
                    <mat-tab label="{{ 'ACCOUNTS_DETAILS' | translate }}" *ngIf="contact.products || contact.omemo || contact.video_bridge || contact.rfc_limit || contact.agb_accepted || contact.admin || contact.username">
                        <!-- Add Content for HR Data -->
                        <div class="detail-contact-tab">
                            <div class="detail-item" *ngIf="!contact.isGroup && contact.username">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-account-circle"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'USER_NAME' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        {{ contact.username}}
                                    </div>
                                    <mat-divider></mat-divider>
                                </div>
                            </div>
                            <div class="detail-item" *ngIf="!contact.isGroup && contact.admin">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-account-plus"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'ROLE_LBL' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        <span *ngIf="contact.admin === 'true'">{{ 'ADMIN' | translate }}</span>
                                        <span *ngIf="contact.admin === 'false'">{{ 'USER' | translate }}</span>
                                    </div>
                                    <mat-divider></mat-divider>
                                </div>
                            </div>
                            <div class="detail-item" *ngIf="!contact.isGroup && contact.agb_accepted">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-checkbox-marked-outline"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'ACCEPTED_TERMS' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        <span *ngIf="contact.agb_accepted === 'true'">
                                            {{ 'AGB_FLAG' | translate }}
                                        </span>
                                        <span *ngIf="contact.agb_accepted === 'false'">
                                            {{ 'NOT_AGB_FLAG' | translate }}
                                        </span>
                                    </div>
                                    <mat-divider></mat-divider>
                                </div>
                            </div>

                            <div class="detail-item" *ngIf="!contact.isGroup && contact.rfc_limit">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-arrow-collapse"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'RFC_LIMIT' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        {{ contact.rfc_limit}}
                                    </div>
                                    <mat-divider></mat-divider>
                                </div>
                            </div>
                            <div class="detail-item" *ngIf="!contact.isGroup && contact.video_bridge">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-video"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'VIDEO_BRIDGE' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        <span *ngIf="contact.video_bridge === 'true'">
                                            {{ 'ALLOW' | translate }}
                                        </span>
                                        <span *ngIf="contact.video_bridge === 'false'">
                                            {{ 'NOT_ALLOW' | translate }}
                                        </span>
                                    </div>
                                    <mat-divider></mat-divider>
                                </div>
                            </div>
                            <div class="detail-item" *ngIf="!contact.isGroup && contact.omemo">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-lock"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'SECURITY_ENCRYPTION' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        <span *ngIf="contact.omemo === 'true'">
                                            {{ 'OMEMO' | translate }}
                                        </span>
                                        <span *ngIf="contact.omemo === 'false'">
                                            {{ 'NOT_OMEMO' | translate }}
                                        </span>
                                    </div>
                                    <mat-divider></mat-divider>
                                </div>
                            </div>
                            <div class="detail-item projects-item" *ngIf="!contact.isGroup && contact.products">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-briefcase"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'PRODUCTS' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        <span *ngFor="let product of contact.products">
                                            {{ product.name }}
                                        </span>
                                    </div>
                                    <mat-divider></mat-divider>
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab label="{{ 'RECENT_ACTIVITY' | translate }}">
                        <!-- Add Recent Activity -->
                        <div class="recent-activity">
                            <mat-tab-group (selectedTabChange)="onSelectedTabChangeActivity($event)">
                                <mat-tab label="{{ 'ALL' | translate }}">
                                    <div class="recent-contact-tab">
                                        <div class="recent-items" *ngIf="!!searchResponse && searchResponse.docs.length > 0">
                                            <div class="recent-item" *ngFor="let item of searchResponse.docs" (click)="openRecentActivity(item)">
                                                <div class="recen-item-inner" *ngIf="item.type === 'mail' || item.type === 'task' || (item.type === 'talk' && !!item.chatType && item.chatType === 'chat')">
                                                    <div class="left">
                                                        <div class="avatar-item">
                                                            <vp-avatar
                                                                [user]="{firstLastCharacters: item.from.charAt(0), color: getBgAvatarColor(item.from), avatarURL: getAvatarUrl(item.from)}">
                                                            </vp-avatar>
                                                        </div>
                                                    </div>
                                                    <div class="right">
                                                        <div class="title">
                                                            <span class="title-content" *ngIf="item.type === 'mail' || item.type === 'task'">{{ item.title}}</span>
                                                            <span class="title-content" *ngIf="item.type === 'talk' && !!item.chatType && item.chatType === 'chat'">{{ item.contentTxt}}</span>
                                                            <span class="item-type"> •
                                                                <span *ngIf="item.type === 'mail'">
                                                                    <mat-icon class="mdi-14px" fontSet="mdi" fontIcon="mdi-email"></mat-icon>
                                                                    {{ 'EMAIL_LBL' | translate }}
                                                                </span>
                                                                <span *ngIf="item.type === 'talk' && !!item.chatType && item.chatType === 'chat'">
                                                                    <mat-icon class="mdi-14px" fontSet="mdi" fontIcon="mdi-message"></mat-icon>
                                                                    {{'CHAT_LEBALE' | translate }}
                                                                </span>
                                                                <span *ngIf="item.type === 'task'">
                                                                    <mat-icon class="mdi-14px" fontSet="mdi" fontIcon="mdi-clipboard"></mat-icon>
                                                                    {{'TASK' | translate }}
                                                                </span>
                                                            </span>
                                                        </div>
                                                        <div class="time">
                                                             {{ item.createdDt | date: "mediumDate"}} <span class="time-hours"> • {{ item.createdDt | date: "hh:mm a"}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <mat-divider *ngIf="item.type === 'mail' || item.type === 'task' || (item.type === 'talk' && !!item.chatType && item.chatType === 'chat')"></mat-divider>
                                            </div>
                                        </div>
                                    </div>
                                </mat-tab>
                                <mat-tab label="{{ 'CHATS' | translate }}">
                                    <div class="recent-contact-tab">
                                        <div class="recent-items" *ngIf="!!searchResponse && searchResponse.docs.length > 0">
                                            <div class="recent-item" *ngFor="let item of searchResponse.docs" (click)="openRecentActivity(item)">
                                                <span *ngIf="item.type === 'talk' && !!item.chatType && item.chatType === 'chat'">
                                                    <div class="recen-item-inner">
                                                        <div class="left">
                                                            <div class="avatar-item">
                                                                <vp-avatar
                                                                    [user]="{firstLastCharacters: item.from.charAt(0), color: getBgAvatarColor(item.from), avatarURL: getAvatarUrl(item.from)}">
                                                                </vp-avatar>
                                                            </div>
                                                        </div>
                                                        <div class="right">
                                                            <div class="title">
                                                                <span class="title-content">{{ item.contentTxt}}</span>
                                                                <span class="item-type"> •
                                                                    <span *ngIf="item.type === 'talk' && !!item.chatType && item.chatType === 'chat'">
                                                                        <mat-icon class="mdi-14px" fontSet="mdi" fontIcon="mdi-message"></mat-icon>
                                                                        {{'CHAT_LEBALE' | translate }}
                                                                    </span>
                                                                </span>
                                                            </div>
                                                            <div class="time">
                                                                {{ item.createdDt | date: "mediumDate"}} <span class="time-hours"> • {{ item.createdDt | date: "hh:mm a"}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <mat-divider></mat-divider>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </mat-tab>
                                <mat-tab label="{{ 'CALLS' | translate }}">
                                    {{ 'COMING_SOON' | translate }}
                                </mat-tab>
                                <mat-tab label="{{ 'EMAILS' | translate }}">
                                    <div class="recent-contact-tab">
                                        <div class="recent-items" *ngIf="!!searchResponse && searchResponse.docs.length > 0">
                                            <div class="recent-item" *ngFor="let item of searchResponse.docs" (click)="openRecentActivity(item)">
                                                <span *ngIf="item.type === 'mail'">
                                                    <div class="recen-item-inner">
                                                        <div class="left">
                                                            <div class="avatar-item">
                                                                <vp-avatar
                                                                    [user]="{firstLastCharacters: item.from.charAt(0), color: getBgAvatarColor(item.from), avatarURL: getAvatarUrl(item.from)}">
                                                                </vp-avatar>
                                                            </div>
                                                        </div>
                                                        <div class="right">
                                                            <div class="title">
                                                                <span class="title-content">{{ item.title}}</span>
                                                                <span class="item-type"> •
                                                                    <span *ngIf="item.type === 'mail'">
                                                                        <mat-icon class="mdi-14px" fontSet="mdi" fontIcon="mdi-email"></mat-icon>
                                                                        {{ 'EMAIL_LBL' | translate }}
                                                                    </span>
                                                                </span>
                                                            </div>
                                                            <div class="time">
                                                                {{ item.createdDt | date: "mediumDate"}} <span class="time-hours"> • {{ item.createdDt | date: "hh:mm a"}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <mat-divider></mat-divider>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </mat-tab>
                                <mat-tab label="{{ 'TASKS' | translate }}">
                                    <div class="recent-contact-tab">
                                        <div class="recent-items" *ngIf="!!searchResponse && searchResponse.docs.length > 0">
                                            <div class="recent-item" *ngFor="let item of searchResponse.docs" (click)="openRecentActivity(item)">
                                                <span *ngIf="item.type === 'task'">
                                                    <div class="recen-item-inner">
                                                        <div class="left">
                                                            <div class="avatar-item">
                                                                <vp-avatar
                                                                    [user]="{firstLastCharacters: item.from.charAt(0), color: getBgAvatarColor(item.from), avatarURL: getAvatarUrl(item.from)}">
                                                                </vp-avatar>
                                                            </div>
                                                        </div>
                                                        <div class="right">
                                                            <div class="title">
                                                                <span class="title-content">{{ item.title}}</span>
                                                                <span class="item-type"> •
                                                                    <span *ngIf="item.type === 'task'">
                                                                        <mat-icon class="mdi-14px" fontSet="mdi" fontIcon="mdi-clipboard"></mat-icon>
                                                                        {{'TASK' | translate }}
                                                                    </span>
                                                                </span>
                                                            </div>
                                                            <div class="time">
                                                                {{ item.createdDt | date: "mediumDate"}} <span class="time-hours"> • {{ item.createdDt | date: "hh:mm a"}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <mat-divider></mat-divider>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </mat-tab>
                                <mat-tab label="{{ 'TICKETS' | translate }}">
                                    {{ 'COMING_SOON' | translate }}
                                </mat-tab>
                            </mat-tab-group>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>

            <!-- Mobile Detail view -->
            <div class="mobile-detail" (touchstart)="$event.stopPropagation();swipe($event, 'start')" (touchend)="$event.stopPropagation();swipe($event, 'end')">
                <mat-tab-group [(selectedIndex)]="selectedTab">
                    <mat-tab label="{{ 'CONTACT_INFO' | translate }}">
                        <div class="detail-contact-tab">
                            <div class="detail-item">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-account"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'FIRST_LAST_NAME_TITLE' | translate }}
                                    </div>
                                    <div class="detail-data">{{ contact?.fullName }}</div>
                                </div>
                            </div>
                            <mat-divider></mat-divider>
                            <div class="detail-item" *ngIf="contact.company || contact.jobTitle">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-city"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'COMPANY_JOB_POSITION' | translate }}
                                    </div>
                                    <div>
                                        <span *ngIf="contact.company"> {{ contact.company }}</span>
                                        <span *ngIf="contact.company && contact.jobTitle">
                                            <mat-icon class="seprator">fiber_manual_record</mat-icon>
                                        </span>
                                        <span *ngIf="contact.jobTitle" class="type">{{ contact.jobTitle }}</span>
                                    </div>
                                </div>
                            </div>
                            <mat-divider *ngIf="contact.company || contact.jobTitle"></mat-divider>
                            <div *ngIf="!contact.isGroup && contact.address && contact.address.length > 0">
                                <div class="detail-item" *ngFor="let address of contact.address; let i= index;">
                                    <div class="icon">
                                        <mat-icon *ngIf="i===0" class="mdi-18px" fontSet="mdi" fontIcon="mdi-map-marker"></mat-icon>
                                    </div>
                                    <div class="detail">
                                        <div class="lable-detail" *ngIf="i===0">
                                            {{ 'ADDRESS' | translate }}
                                        </div>
                                        <div *ngIf="lang !== 'de'">
                                            <span (click)="parseAddressLocation(address)">
                                                {{ getAddress(address) }}
                                             </span>
                                             <span>
                                                 <mat-icon class="seprator">fiber_manual_record</mat-icon>
                                             </span>
                                             <span class="type">
                                                {{ (address.address_type === "home" ? 'ADDRESS_TYPE.HOME' : address.address_type === "work" ? 'ADDRESS_TYPE.WORK' : 'ADDRESS_TYPE.OTHER') | translate }}
                                             </span>
                                        </div>
                                        <div *ngIf="lang === 'de'">
                                            <span class="background-text-color" (click)="parseAddressLocation(address)">
                                                <span>
                                                    <mat-icon class="seprator">fiber_manual_record</mat-icon>
                                                </span>
                                                <span class="type">
                                                    {{ (address.address_type === "home" ? 'ADDRESS_TYPE.HOME' : address.address_type === "work" ? 'ADDRESS_TYPE.WORK' : 'ADDRESS_TYPE.OTHER') | translate }}
                                                </span>
                                                <div *ngIf='address.street1 && address.street1 !== null && address.street1 !== ""' class="address-text-size">
                                                    {{ address.street1 }}
                                                </div>
                                                <div>
                                                    <div>
                                                        <span *ngIf='address.postcode && address.postcode !== null && address.postcode !== ""' class="address-text-size"> {{address.postcode}} </span>
                                                        <span *ngIf='address.city && address.city !== null && address.city !== ""' class="address-text-size"> {{ address.city }} </span>
                                                    </div>
                                                    <span *ngIf='address.state && address.state !== null && address.state !== ""' class="address-text-size">  {{address.state}} </span>
                                                </div>
                                                <span *ngIf='address.country_code && address.country_code !== null && address.country_code !== ""' class="address-text-size">
                                                    {{address.country_code}}
                                                </span>
                                             </span>
                                        </div>
                                    </div>
                                </div>
                                <mat-divider></mat-divider>
                            </div>
                            <div *ngIf="!contact.isGroup && contact.phones?.length > 0">
                                <div class="detail-item" *ngFor="let phone of contact.phones; let i= index;">
                                    <div class="icon">
                                        <mat-icon *ngIf="i===0" class="mdi-18px" fontSet="mdi" fontIcon="mdi-phone"></mat-icon>
                                    </div>
                                    <div class="detail">
                                        <div class="lable-detail" *ngIf="i===0">
                                            {{ 'PHONE_MOBILE_FAX' | translate }}
                                        </div>
                                        <div>
                                            <span (click)="callPhoneNumber(phone.phone)">
                                                {{ phone.phone}}
                                            </span>
                                            <span>
                                                <mat-icon class="seprator">fiber_manual_record</mat-icon>
                                            </span>
                                            <span class="type">
                                                {{ (phone.phone_type === "home" ? 'PHONE_TYPE.HOME' : phone.phone_type === "work" ? 'PHONE_TYPE.WORK' : 'PHONE_TYPE.OTHER') | translate }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <mat-divider></mat-divider>
                            </div>
                            <!-- JID -->
                            <div *ngIf="!contact?.isGroup && contact?.jid">
                                <div class="detail-item">
                                    <div class="icon">
                                        <svg  width="18px" height="18px" viewBox="0 0 96 96" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <g id="Icon/vnc/talk-new-grayscale-noborder" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                <circle id="Oval" fill="#A8B0B9" fill-rule="nonzero" cx="48" cy="48" r="48"></circle>
                                                <g id="VNCtalk" transform="translate(15.600000, 22.800000)" fill-rule="nonzero">
                                                    <path d="M36.828,42.312 C35.916,42.828 35.052,43.428 34.116,43.896 C26.8560252,47.5758323 18.1956331,47.1656032 11.316,42.816 C11.076,42.672 10.968,42.708 10.788,42.9 C9.4572144,44.4238971 7.33072703,44.9804945 5.424,44.304 C3.6681935,43.7333634 2.35239421,42.2662001 1.97555531,40.4588609 C1.5987164,38.6515217 2.21854457,36.7807708 3.6,35.556 C3.852,35.34 3.9,35.208 3.72,34.896 C-1.49015879,25.9903236 -0.125967095,14.7038455 7.056,7.296 C10.7094647,3.45087823 15.5985507,1.01270673 20.868,0.408 C30.8091147,-0.80850851 40.4008719,4.52293814 44.616,13.608 C44.616,13.728 44.736,13.836 44.796,13.944 C44.7902095,14.0118767 44.7902095,14.0801233 44.796,14.148 C45.8511954,16.5033409 46.4848077,19.0256052 46.668,21.6 C47.180873,28.7590539 44.3333864,35.7491456 38.964,40.512 C38.268,41.184 37.512,41.7 36.828,42.312 Z M30,12.636 C28.6596044,12.6846181 27.3421727,12.9986808 26.124,13.56 C21.5565091,15.6900118 17.7018796,19.0945874 15.024,23.364 C13.7012763,25.2257396 12.8752429,27.3940772 12.624,29.664 C12.4750155,30.5480184 12.7765517,31.4481266 13.428,32.064 C14.412,33.012 15.36,33.996 16.332,34.968 C16.5653772,35.3072549 16.9681645,35.4884333 17.376837,35.4379799 C17.7855096,35.3875265 18.1321391,35.1138275 18.276,34.728 C19.132,33.28 19.988,31.832 20.844,30.384 C21.3050905,29.7253314 21.1851694,28.8233161 20.568,28.308 C20.22,27.96 19.884,27.6 19.512,27.288 C19.2452661,27.0763112 19.1562976,26.7105517 19.296,26.4 C19.4778591,25.8676293 19.7322547,25.3628761 20.052,24.9 C21.1958491,23.2362631 22.60213,21.769192 24.216,20.556 C24.8495674,20.0495665 25.5580308,19.6447303 26.316,19.356 C26.6364623,19.2016703 27.0211627,19.2916002 27.24,19.572 C27.552,19.932 27.9,20.256 28.248,20.58 C28.6771629,21.0158701 29.3435232,21.1138642 29.88,20.82 L34.608,18.324 C34.9946309,18.1885227 35.2744492,17.8500872 35.334852,17.4448848 C35.3952549,17.0396823 35.2263088,16.6343503 34.896,16.392 C33.936,15.42 32.952,14.472 32.004,13.488 C31.5005672,12.9136884 30.7628806,12.6000611 30,12.636 L30,12.636 Z" id="Shape" fill="#FEFEFE"></path>
                                                    <path d="M36.828,42.312 C37.512,41.7 38.268,41.184 38.964,40.572 C44.3523812,35.7970648 47.2018943,28.7798061 46.668,21.6 C46.5003755,19.0155647 45.8788825,16.480848 44.832,14.112 C44.8262095,14.0441233 44.8262095,13.9758767 44.832,13.908 C47.6903074,13.3727337 50.6413293,13.647054 53.352,14.7 C58.7389502,16.6683095 62.6527119,21.3794887 63.6,27.036 C64.3821378,30.8569551 63.7103152,34.8322625 61.716,38.184 C61.6437511,38.2700043 61.6127806,38.3833301 61.6312465,38.4941256 C61.6497124,38.6049211 61.7157632,38.7020767 61.812,38.76 C62.9501103,39.7841083 63.3159683,41.4160275 62.724,42.828 C62.1600227,44.1963349 60.8319405,45.0943264 59.352,45.108 C58.3572924,45.1259443 57.4018485,44.7202078 56.724,43.992 C56.6691183,43.9050874 56.5786208,43.8468838 56.4767733,43.8329955 C56.3749259,43.8191072 56.2721486,43.8509552 56.196,43.92 C50.2454255,47.6163142 42.5990288,47.09947 37.2,42.636 C37.044,42.54 36.936,42.42 36.828,42.312 Z" id="Path" fill="#DADEE2"></path>
                                                </g>
                                            </g>
                                        </svg>
                                    </div>
                                    <div class="detail">
                                        <div class="lable-detail">
                                            {{ 'JID' | translate }}
                                        </div>
                                        <div>
                                            <span (click)="composeEmail(contact?.jid)">
                                                {{ contact?.jid}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <mat-divider></mat-divider>
                            </div>
                            <div *ngIf="!contact.isGroup && contact.emails?.length > 0">
                                <div class="detail-item" *ngFor="let email of contact.emails; let i= index;">
                                    <div class="icon">
                                        <mat-icon *ngIf="i===0" class="mdi-18px" fontSet="mdi" fontIcon="mdi-email"></mat-icon>
                                    </div>
                                    <div class="detail">
                                        <div class="lable-detail" *ngIf="i===0">
                                            {{ 'EMAILS' | translate }}
                                        </div>
                                        <div>
                                            <span (click)="composeEmail(email.email)">
                                                {{ email.email}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <mat-divider></mat-divider>
                            </div>
                            <div *ngIf="!contact.isGroup && contact.urls?.length > 0">
                                <div class="detail-item" *ngFor="let url of contact.urls; let i= index;">
                                    <div class="icon">
                                        <mat-icon *ngIf="i===0" class="mdi-18px" fontSet="mdi" fontIcon="mdi-link"></mat-icon>
                                    </div>
                                    <div class="detail">
                                        <div class="lable-detail" *ngIf="i===0">
                                            {{ 'WEBSITE' | translate }}
                                        </div>
                                        <div>
                                            <span (click)="openUrlNewTab(url.url)">
                                                {{ url.url }}
                                            </span>
                                            <span>
                                                <mat-icon class="seprator">fiber_manual_record</mat-icon>
                                            </span>
                                            <span class="type">
                                                {{ (url.url_type === "home" ? 'URL_TYPE.HOME' : url.url_type === "work" ? 'URL_TYPE.WORK' : 'URL_TYPE.OTHER') | translate }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <mat-divider></mat-divider>
                            </div>
                            <div *ngIf="!contact.isGroup && contact.events && contact.events.length > 0">
                                <div class="detail-item" *ngFor="let event of contact.events; let i= index;">
                                    <div class="icon">
                                        <mat-icon *ngIf="i===0" class="mdi-18px" fontSet="mdi" fontIcon="mdi-cake-variant"></mat-icon>
                                    </div>
                                    <div class="detail">
                                        <span>
                                            {{ event.event_date | date: 'M/d/yyyy' }}
                                        </span>
                                        <span>
                                            <mat-icon class="seprator">fiber_manual_record</mat-icon>
                                        </span>
                                        <span class="type">
                                            {{ (event.event_type === "birthday" ? 'CONTACT_EVENT_TYPE.BIRTHDAY' : event.event_type === "anniversary" ? 'CONTACT_EVENT_TYPE.ANNIVERSARY' : 'CONTACT_EVENT_TYPE.CUSTOM') | translate }}
                                        </span>
                                    </div>
                                </div>
                                <mat-divider></mat-divider>
                            </div>
                            <div class="detail-caption-title">
                                {{ 'CONTACT_DETAILS' | translate }}
                            </div>
                            <div class="detail-item" *ngIf="contact.timezone">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-calendar-clock"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'TIME_ZONE' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        {{ contact.timezone }}
                                    </div>
                                </div>
                            </div>
                            <mat-divider *ngIf="contact.timezone"></mat-divider>
                            <div class="detail-item" *ngIf="contact.language">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-flag"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'LANGUAGE_LABEL' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        {{ contact.language }}
                                    </div>
                                </div>
                            </div>
                            <mat-divider *ngIf="contact.language"></mat-divider>
                            <div *ngIf="!contact.isGroup && contact.skills && contact.skills.length > 0">
                                <div class="detail-item">
                                    <div class="icon list-chips-icon margin-top-15">
                                        <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-account"></mat-icon>
                                    </div>
                                    <div class="detail list-chips">
                                        <div class="lable-detail">
                                            {{ 'SKILLS' | translate }}
                                        </div>
                                        <div>
                                            <mat-chip-list #contactChipList>
                                                <mat-chip
                                                  *ngFor="let skill of contact.skills"
                                                  [selectable]="true"
                                                  [removable]="false"
                                                  [ngStyle]="{'background': '#607D8B'}"
                                                  >
                                                  <span class="name">{{skill.name}}</span>
                                                </mat-chip>
                                            </mat-chip-list>
                                        </div>
                                    </div>
                                </div>
                                <mat-divider></mat-divider>
                            </div>
                            <div *ngIf="!contact.isGroup && contact.interests && contact.interests.length > 0">
                                <div class="detail-item">
                                    <div class="icon list-chips-icon margin-top-15">
                                        <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-guitar-acoustic"></mat-icon>
                                    </div>
                                    <div class="detail list-chips">
                                        <div class="lable-detail">
                                            {{ 'INTERESTS' | translate }}
                                        </div>
                                        <div>
                                            <mat-chip-list #contactChipList>
                                                <mat-chip
                                                  *ngFor="let interest of contact.interests"
                                                  [selectable]="true"
                                                  [removable]="false"
                                                  [ngStyle]="{'background': '#607D8B'}"
                                                  >
                                                  <span class="name">{{interest.name}}</span>
                                                </mat-chip>
                                            </mat-chip-list>
                                        </div>
                                    </div>
                                </div>
                                <mat-divider></mat-divider>
                            </div>
                            <div *ngIf="!contact.isGroup && contact.tags && contact.tags.length > 0">
                                <div class="detail-item">
                                    <div class="icon list-chips-icon margin-top-15">
                                        <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-tag"></mat-icon>
                                    </div>
                                    <div class="detail list-chips">
                                        <div class="lable-detail">
                                            {{ 'TAGS' | translate }}
                                        </div>
                                        <div>
                                            <span>
                                                <mat-chip-list #contactChipTag>
                                                    <mat-chip
                                                      *ngFor="let tag of contact.tags"
                                                      [selectable]="true"
                                                      [removable]="false"
                                                      class="tag-list-chip"
                                                      [ngStyle]="{'background': tag.color_hex ? tag.color_hex : '#888888'}"
                                                      >
                                                      <span class="name">{{tag.name}}</span>
                                                    </mat-chip>
                                                </mat-chip-list>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <mat-divider></mat-divider>
                            </div>
                            <div *ngIf="!contact.isGroup && contact.contact_list && contact.contact_list.length > 0">
                                <div class="detail-item">
                                    <div class="icon list-chips-icon margin-top-15">
                                        <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-account-box-multiple"></mat-icon>
                                    </div>
                                    <div class="detail list-chips">
                                        <div class="lable-detail">
                                            {{ 'LISTS_LBL' | translate }}
                                        </div>
                                        <div>
                                            <span>
                                                <mat-chip-list #contactChipList>
                                                    <mat-chip
                                                      *ngFor="let list of contact.contact_list"
                                                      [selectable]="true"
                                                      [removable]="false"
                                                      [ngStyle]="{'background': list.color_hex !== null ? list.color_hex : '#888888'}"
                                                      >
                                                      <span class="name">{{list.name}}</span>
                                                    </mat-chip>
                                                </mat-chip-list>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <mat-divider></mat-divider>
                            </div>
                            <div *ngIf="!contact.isGroup && contact.notes">
                                <div class="detail-item">
                                    <div class="icon">
                                        <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-note-text"></mat-icon>
                                    </div>
                                    <div class="detail">
                                        <span>
                                            {{ contact.notes }}
                                        </span>
                                    </div>
                                </div>
                                <mat-divider></mat-divider>
                            </div>
                            <div class="detail-caption-title" *ngIf="!contact.isGroup && contact.custom_fields && contact.custom_fields.length > 0">
                                {{ 'CUSTOM_DETAILS' | translate }}
                            </div>
                            <div *ngIf="!contact.isGroup && contact.custom_fields && contact.custom_fields.length > 0">
                                <div *ngFor="let custom_field of contact.custom_fields">
                                    <div class="detail-item">
                                        <div class="icon">
                                            <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-file-document"></mat-icon>
                                        </div>
                                        <div class="detail">
                                            <div class="lable-detail">
                                                {{ custom_field.field_name }}
                                            </div>
                                            <div class="detail-data">
                                                {{ custom_field.field_value }}
                                            </div>
                                        </div>
                                    </div>
                                    <mat-divider></mat-divider>
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab label="{{ 'HR_DATA' | translate }}" *ngIf="contact?.contains_hr_data === 'true'">
                        <!-- Add Content for HR Data -->
                        <div class="detail-contact-tab">
                            <div class="detail-item" *ngIf="!contact.isGroup && contact.birthday">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-cake"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'DATE_OF_BIRTH' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        {{ contact.birthday | date: "d. MMMM y"}}
                                    </div>
                                </div>
                            </div>
                            <mat-divider *ngIf="!contact.isGroup && contact.birthday"></mat-divider>
                            <div class="detail-item" *ngIf="!contact.isGroup && (contact.gender || contact.marital_status)">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-human-male-female"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="multi-field">
                                        <div>
                                            <div class="lable-detail">
                                                {{ 'GENDER' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.gender}}
                                            </div>
                                        </div>
                                        <div class="margin-top-15">
                                            <div class="lable-detail">
                                                {{ 'MARITAL_STATUS' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.marital_status}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <mat-divider *ngIf="!contact.isGroup && (contact.gender || contact.marital_status)"></mat-divider>
                            <div class="detail-item" *ngIf="!contact.isGroup && contact.private_email">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-email"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'PRIVATE_EMAIL' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        {{ contact.private_email}}
                                    </div>
                                </div>
                            </div>
                            <mat-divider *ngIf="!contact.isGroup && contact.private_email"></mat-divider>
                            <div class="detail-item" *ngIf="!contact.isGroup && contact.vnc_employee">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-account"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'ENGAGEMENT_TYPE' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        <span *ngIf="contact.vnc_employee === 'true'">
                                            {{ 'VNC_EMPLOYEE' | translate }}
                                        </span>
                                        <span *ngIf="contact.vnc_employee === 'false'">
                                            {{ 'NOT_VNC_EMPLOYEE' | translate }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <mat-divider *ngIf="!contact.isGroup && contact.vnc_employee"></mat-divider>
                            <div class="detail-item" *ngIf="!contact.isGroup && (contact.start_date || contact.end_date)">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-calendar-today"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="multi-field">
                                        <div *ngIf="contact.start_date">
                                            <div class="lable-detail">
                                                {{ 'START_DATE' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.start_date | date: "d. MMMM y"}}
                                            </div>
                                        </div>
                                        <div class="margin-top-15" *ngIf="contact.end_date">
                                            <div class="lable-detail">
                                                {{ 'END_DATE' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.end_date | date: "d. MMMM y"}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <mat-divider *ngIf="!contact.isGroup && (contact.start_date || contact.end_date)"></mat-divider>
                            <div class="detail-item" *ngIf="!contact.isGroup && (contact.per_week_availability || contact.hourly_rate || contact.payment_mode)">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-currency-usd-circle-outline"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="multi-field">
                                        <div *ngIf="contact.per_week_availability">
                                            <div class="lable-detail">
                                                {{ 'PER_WEEK_AVAILABLILITY' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.per_week_availability}}
                                            </div>
                                        </div>
                                        <div *ngIf="contact.hourly_rate" class="margin-top-15">
                                            <div class="lable-detail">
                                                {{ 'HOURLY_RATE' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.hourly_rate}}
                                            </div>
                                        </div>
                                        <div *ngIf="contact.payment_mode" class="margin-top-15">
                                            <div class="lable-detail">
                                                {{ 'PAYMENT_MODE' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.payment_mode}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <mat-divider *ngIf="!contact.isGroup && (contact.per_week_availability || contact.hourly_rate || contact.payment_mode)"></mat-divider>
                            <div *ngIf="!contact.isGroup && contact.im_accounts && contact.im_accounts.length > 0">
                                <div class="detail-item" *ngFor="let im of contact.im_accounts; let i= index;">
                                    <div class="icon">
                                        <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-forum" *ngIf="i === 0"></mat-icon>
                                    </div>
                                    <div class="detail">
                                        <span>
                                            {{ im.im_id }}
                                        </span>
                                        <span>
                                            <mat-icon class="seprator">fiber_manual_record</mat-icon>
                                        </span>
                                        <span class="type">
                                            {{ im.im_type }}
                                        </span>
                                    </div>
                                </div>
                                <mat-divider></mat-divider>
                            </div>
                            <div class="detail-item" *ngIf="!contact.isGroup && (contact.passport_number || contact.passport_expiry)">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-passport"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="multi-field">
                                        <div *ngIf="contact.passport_number">
                                            <div class="lable-detail">
                                                {{ 'PASSPORT_NUMBER' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.passport_number}}
                                            </div>
                                        </div>
                                        <div *ngIf="contact.passport_expiry" class="margin-top-15">
                                            <div class="lable-detail">
                                                {{ 'PASSPORT_EXPIRY' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.passport_expiry | date: "d. MMMM y"}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <mat-divider *ngIf="!contact.isGroup && (contact.passport_number || contact.passport_expiry)"></mat-divider>
                            <div class="detail-item" *ngIf="!contact.isGroup && (contact.national_id_number || contact.national_id_expiry)">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-account-card-details"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="multi-field">
                                        <div *ngIf="contact.national_id_number">
                                            <div class="lable-detail">
                                                {{ 'NATIONAL_ID_NUMBER' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.national_id_number}}
                                            </div>
                                        </div>
                                        <div *ngIf="contact.national_id_expiry !== null" class="margin-top-15">
                                            <div class="lable-detail">
                                                {{ 'NATIONAL_ID_EXPIRY' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.national_id_expiry | date: "d. MMMM y"}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <mat-divider *ngIf="!contact.isGroup && (contact.passport_number || contact.passport_expiry)"></mat-divider>
                        </div>
                    </mat-tab>
                    <mat-tab label="{{ 'ACCOUNTS_DETAILS' | translate }}" *ngIf="contact.products || contact.omemo || contact.video_bridge || contact.rfc_limit || contact.agb_accepted || contact.admin || contact.username">
                        <!-- Add Content for HR Data -->
                        <div class="detail-contact-tab">
                            <div class="detail-item" *ngIf="!contact.isGroup && contact.username">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-account-circle"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'USER_NAME' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        {{ contact.username}}
                                    </div>
                                </div>
                            </div>
                            <mat-divider *ngIf="!contact.isGroup && contact.username"></mat-divider>
                            <div class="detail-item" *ngIf="!contact.isGroup && contact.admin">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-account-plus"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'ROLE_LBL' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        <span *ngIf="contact.admin === 'true'">{{ 'ADMIN' | translate }}</span>
                                        <span *ngIf="contact.admin === 'false'">{{ 'USER' | translate }}</span>
                                    </div>
                                </div>
                            </div>
                            <mat-divider *ngIf="!contact.isGroup && contact.admin"></mat-divider>
                            <div class="detail-item" *ngIf="!contact.isGroup && contact.agb_accepted">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-checkbox-marked-outline"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'ACCEPTED_TERMS' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        <span *ngIf="contact.agb_accepted === 'true'">
                                            {{ 'AGB_FLAG' | translate }}
                                        </span>
                                        <span *ngIf="contact.agb_accepted === 'false'">
                                            {{ 'NOT_AGB_FLAG' | translate }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <mat-divider *ngIf="!contact.isGroup && contact.agb_accepted"></mat-divider>
                            <div class="detail-item" *ngIf="!contact.isGroup && contact.rfc_limit">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-arrow-collapse"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'RFC_LIMIT' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        {{ contact.rfc_limit}}
                                    </div>
                                </div>
                            </div>
                            <mat-divider *ngIf="!contact.isGroup && contact.rfc_limit"></mat-divider>
                            <div class="detail-item" *ngIf="!contact.isGroup && contact.video_bridge">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-video"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'VIDEO_BRIDGE' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        <span *ngIf="contact.video_bridge === 'true'">
                                            {{ 'ALLOW' | translate }}
                                        </span>
                                        <span *ngIf="contact.video_bridge === 'false'">
                                            {{ 'NOT_ALLOW' | translate }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <mat-divider *ngIf="!contact.isGroup && contact.video_bridge"></mat-divider>
                            <div class="detail-item" *ngIf="!contact.isGroup && contact.omemo">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-lock"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'SECURITY_ENCRYPTION' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        <span *ngIf="contact.omemo === 'true'">
                                            {{ 'OMEMO' | translate }}
                                        </span>
                                        <span *ngIf="contact.omemo === 'false'">
                                            {{ 'NOT_OMEMO' | translate }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <mat-divider *ngIf="!contact.isGroup && contact.omemo"></mat-divider>
                            <div class="detail-item projects-item" *ngIf="!contact.isGroup && contact.products">
                                <div class="icon">
                                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-briefcase"></mat-icon>
                                </div>
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'PRODUCTS' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        <span *ngFor="let product of contact.products">
                                            {{ product.name }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <mat-divider *ngIf="!contact.isGroup && contact.products"></mat-divider>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
            <!-- End of Mobile Detail view -->
        </div>
    </div>
    <mat-menu #contactOperationMenu="matMenu" [class]="'contact-plus-mat-menu'">
        <button mat-menu-item (click)="shareContact()" *ngIf="isCordova">
            <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-share"></mat-icon>
            <span>{{ 'SHARE' | translate }}</span>
        </button>
        <button mat-menu-item (click)="printContact()">
            <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-printer"></mat-icon>
            <span>{{ 'PRINT' | translate }}</span>
        </button>
        <button mat-menu-item (click)="exportContact()">
            <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-package-up"></mat-icon>
            <span>{{ 'EXPORT_LABEL' | translate }}</span>
        </button>
        <button mat-menu-item (click)="deleteContact()" [disabled]="contact.is_global">
            <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-delete"></mat-icon>
            <span>{{ 'DELETE' | translate }}</span>
        </button>
    </mat-menu>
</div>